<template>
  <div class="brandinfo">
    <h4>{{ brand.title }}</h4>
    <p>{{ brand.des }}</p>
    <img @click.prevent
         class="brandinfo-img"
         :src="brand.banner">
    <div class="brandinfo-title">
      <img @click.prevent
           :src="ICON">
      {{ brand.position.title }}
    </div>
    <p class="brandinfo-title-p">{{ brand.position.txt }}</p>
    <div class="brandinfo-title">
      <img @click.prevent
           :src="ICON">
      {{ brand.bizs.title }}
    </div>
    <p class="brandinfo-biz"
       v-for="(b, i) in brand.bizs.item"
       :key="i">
      <span class="brandinfo-biz-title"
            v-html="b.title"></span>
      <span class="brandinfo-biz-des"
            v-html="b.des"></span>
    </p>
    <div class="brandinfo-gtwork"
         v-show="id === 1">
      <ul class="brandinfo-gtwork-ul">
        <li v-for="(gtwork, index) in showData.GTWORKS"
            :key="index">
          <img @click.prevent
               :src="gtwork.img">
        </li>
      </ul>
      <img @click.prevent
           :src="showData.footImg"
           width="100%">
      <p v-html="showData.footerTxt"
         class="brandinfo-footer"></p>
    </div>
  </div>
</template>

<script>

import language from 'mixins/language' // 预留 多语言混入实例
export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      id: 0,
      ICON: require('images/brand/point.png'),
      brand: {},
      CN: {
        footImg: require('images/brand/gt6.png'),
        GTWORKS: [
          { img: require('images/brand/gt1.png') },
          { img: require('images/brand/gt2.png') },
          { img: require('images/brand/gt3.png') },
          { img: require('images/brand/gt4.png') },
          { img: require('images/brand/gt5.png') }
        ],
        footerTxt: '以科技为核心，通过立体公园式环境、生活社交中心、文化交流平台、互联网植入，构建出一个充满温情、自然、人文的办公社区，为个人和企业提供专业、多维度的办公服务。<br>专业办公服务平台，提供基础办公、广告营销、商务交流的一站式服务；<br>线上办公服务系统，为中小型、创新型企业节约管理成本，助力商业孵化；<br>灵活办公租赁，为个人、创业团队提供工位，节约创业成本并带来商机/工作对接；<br>商务休闲设施一应俱全，生活工作两不误。',
        BRANDS: [
          {
            id: 1,
            title: 'GT WORK',
            des: '任何时间、任何地点服务客户，助力客户事业成功',
            banner: require('images/brand/11.png'),
            position: { title: '品牌定位', txt: '提供专业、多维度的办公服务，领先的写字楼专业运营服务商' },
            bizs: {
              title: '业务体系',
              item: [{
                title: '标准写字楼：',
                des: '广州高德置地广场写字楼/高德大厦/高德中心/杭州高德广场写字楼/株洲·优易大厦；'
              },
              {
                title: 'WORK INFINITY：',
                des: '以科技为核心，通过立体公园式环境、生活社交中心、文化交流平台、互联网植入，构建出一个充满温情、自然、人文的创新办公社区；'
              }]
            }
          },
          {
            id: 2,
            title: '天为食',
            des: '致力于打造以“智能科技+餐饮社交文化”的美食娱乐体验',
            banner: require('images/brand/22.png'),
            position: { title: '品牌定位', txt: '打造从农场到餐桌的全链条服务提供平台' },
            bizs: {
              title: '业务体系',
              item: [{
                title: 'Lebazar：',
                des: '集生鲜超市、美食大厅、广场集市等，打造科技与食材结合的美食乐园；'
              },
              {
                title: '科技农场：',
                des: '展示农场——餐桌的全过程。提供不同国家、地区的美食文化体验；'
              },
              {
                title: 'Fun land：',
                des: '汇聚世界各地餐饮品牌，打造体验、科技、娱乐、零售于一体的欢乐美食之旅；'
              }]
            }
          },
          {
            id: 3,
            title: 'Liber Fashion',
            des: '时尚是自由的，顾客可以自由选择属于自己的时尚',
            banner: require('images/brand/33.png'),
            position: { title: '品牌定位', txt: '时尚和美妆的主题服务体验平台' },
            bizs: {
              title: '业务体系',
              item: [
                {
                  title: 'Liber Fashion：',
                  des: '名品实体店、品牌文化体验店、7大时装周主题展；'
                },
                {
                  title: 'Liber Beauty：',
                  des: '形象定制、美容、香水、美发、美甲、化妆、护肤品集合店等；'
                },
                {
                  title: 'Liber Stage：',
                  des: '通过实体、线上和虚拟呈现，给消费者带来多维度的五大时尚周现场体验；'
                }]
            }
          },
          {
            id: 4,
            title: '童年时光',
            des: '陪伴儿童快乐健康成长',
            banner: require('images/brand/44.png'),
            position: { title: '品牌定位', txt: '整合儿童产业资源为儿童及家庭提供多元化服务平台' },
            bizs: {
              title: '业务体系',
              item: [
                {
                  title: '儿童游乐：',
                  des: '儿童教育平台、儿童潜能、儿童自由表达学习平台；'
                },
                {
                  title: 'Global Expressions：',
                  des: '以科技为核心，通过立体公园式环境、生活社交中心、文化交流平台、互联网植入，构建出一个充满温情、自然、人文的创新办公社区；'
                },
                {
                  title: '少儿运动：',
                  des: '少儿运动健康平台、多元化运动元素、亲子运动体验；'
                },
                {
                  title: '科技娱乐：',
                  des: '科技与娱乐融合的欢乐世界；'
                }]
            }
          },
          {
            id: 5,
            title: '美居生活',
            des: '以艺术、阅读与音乐为语言，追求喜悦与欢笑为生活态度 ，充实人们的精神生活',
            banner: require('images/brand/55.png'),
            position: { title: '品牌定位', txt: '家的延伸，文化与艺术无所不在' },
            bizs: {
              title: '业务体系',
              item: [
                {
                  title: '图书元素：',
                  des: '喜悦图书馆、融合家居、艺廊、花艺、旅游等，打造无边界阅读空间；'
                },
                {
                  title: '艺术元素：',
                  // eslint-disable-next-line no-useless-escape
                  des: 'JAM\创客工坊等，以艺术为基因，用社交和科技赋能，铸造高品味文化与生活享受；'
                },
                {
                  title: '音乐元素：',
                  des: '音创基地，全套音乐服务的社交空间；'
                },
                {
                  title: '未来生活馆：',
                  des: '汇集家居、服饰、美妆、旅游、宠物等，融合科技为生活创造无限可能；'
                }]
            }
          },
          {
            id: 6,
            title: '活力基地',
            des: '为全民带来健康与活力',
            banner: require('images/brand/66.png'),
            position: { title: '品牌定位', txt: '集运动和健康主题于一体的智能生态圈' },
            bizs: {
              title: '业务体系',
              item: [
                {
                  title: '运动版块：',
                  des: '活力运动汇 / 活力冰之城 / 活力加油站 / 活力大球场 / 活力DIY；'
                },
                {
                  title: '健康版块：',
                  des: '有赏马拉松/ 健康导航，以硬件加软件组合方式为消费者提供健康管理服务；'
                },
                {
                  title: '虚拟版块：',
                  des: '无人零售 Brand Stag/e虚拟马拉松；'
                }
              ]
            }
          }
        ]
      },
      ZH: {
        footImg: require('images/brand/gt6_1.png'),
        GTWORKS: [
          { img: require('images/brand/gt1_1.png') },
          { img: require('images/brand/gt2_1.png') },
          { img: require('images/brand/gt3_1.png') },
          { img: require('images/brand/gt4_1.png') },
          { img: require('images/brand/gt5_1.png') }
        ],
        footerTxt: '以科技為核心，通過立體公園式環境、生活社交中心、文化交流平臺、互聯網植入，構建出一個充滿溫情、自然、人文的辦公社區，為個人和企業提供專業、多維度的辦公服務。<br>專業辦公服務平臺，提供基礎辦公、廣告行銷、商務交流的一站式服務；<br>線上辦公服務系統，為中小型、創新型企業節約管理成本，助力商業孵化；<br>靈活辦公租賃，為個人、創業團隊提供工位，節約創業成本並帶來商機/工作對接；<br>商務休閒設施一應俱全，生活工作兩不誤。',
        BRANDS: [
          {
            id: 1,
            title: 'GT WORK',
            des: '任何時間、任何地點服務客戶，助力客戶事業成功',
            banner: require('images/brand/11.png'),
            position: { title: '品牌定位', txt: '提供專業、多維度的辦公服務，領先的寫字樓專業運營服務商' },
            bizs: {
              title: '業務體系',
              item: [{
                title: '標準寫字樓：',
                des: '廣州高德置地廣場寫字樓/高德大廈/高德中心/杭州高德廣場寫字樓/株洲·優易大廈；'
              },
              {
                title: 'WORK INFINITY：',
                des: '以科技為核心，通過立體公園式環境、生活社交中心、文化交流平臺、互聯網植入，構建出一個充滿溫情、自然、人文的創新辦公社區；'
              }]
            }
          },
          {
            id: 2,
            title: '天为食',
            des: '致力於打造以“智慧科技+餐飲社交文化”的美食娛樂體驗',
            banner: require('images/brand/22.png'),
            position: { title: '品牌定位', txt: '打造從農場到餐桌的全鏈條服務提供平臺' },
            bizs: {
              title: '業務體系',
              item: [{
                title: 'Lebazar：',
                des: '集生鮮超市、美食大廳、廣場集市等，打造科技與食材結合的美食樂園；'
              },
              {
                title: '科技农场：',
                des: '展示農場——餐桌的全過程。提供不同國家、地區的美食文化體驗；'
              },
              {
                title: 'Fun land：',
                des: '彙聚世界各地餐飲品牌，打造體驗、科技、娛樂、零售於一體的歡樂美食之旅；'
              }]
            }
          },
          {
            id: 3,
            title: 'Liber Fashion',
            des: '時尚是自由的，顧客可以自由選擇屬於自己的時尚',
            banner: require('images/brand/33.png'),
            position: { title: '品牌定位', txt: '時尚和美妝的主題服務體驗平臺' },
            bizs: {
              title: '業務體系',
              item: [
                {
                  title: 'Liber Fashion：',
                  des: '名品實體店、品牌文化體驗店、7大時裝周主題展；'
                },
                {
                  title: 'Liber Beauty：',
                  des: '形象定制、美容、香水、美髮、美甲、化妝、護膚品集合店等；'
                },
                {
                  title: 'Liber Stage：',
                  des: '通過實體、線上和虛擬呈現，給消費者帶來多維度的五大時尚周現場體驗；'
                }]
            }
          },
          {
            id: 4,
            title: '童年时光',
            des: '陪伴兒童快樂健康成長',
            banner: require('images/brand/44.png'),
            position: { title: '品牌定位', txt: '整合兒童產業資源為兒童及家庭提供多元化服務平台' },
            bizs: {
              title: '業務體系',
              item: [
                {
                  title: '兒童遊樂：',
                  des: '小Q親子樂園、主題歡樂空間等；'
                },
                {
                  title: 'Global Expressions：',
                  des: '兒童教育平臺、兒童潛能、兒童自由表達學習平臺；'
                },
                {
                  title: '少兒運動：',
                  des: '少兒運動健康平臺、多元化運動元素、親子運動體驗；'
                },
                {
                  title: '科技娛樂：',
                  des: '科技與娛樂融合的歡樂世界；'
                }]
            }
          },
          {
            id: 5,
            title: '美居生活',
            des: '以藝術、閱讀與音樂為語言，追求喜悅與歡笑為生活態度 ，充實人們的精神生活',
            banner: require('images/brand/55.png'),
            position: { title: '品牌定位', txt: '家的延伸，文化與藝術無所不在' },
            bizs: {
              title: '業務體系',
              item: [
                {
                  title: '圖書元素：',
                  des: '喜悅圖書館、融合家居、藝廊、花藝、旅遊等，打造無邊界閱讀空間；'
                },
                {
                  title: '藝術元素：',
                  // eslint-disable-next-line no-useless-escape
                  des: 'JAM/創客工坊等，以藝術為基因，用社交和科技賦能，鑄造高品味文化與生活享受；'
                },
                {
                  title: '音樂元素：',
                  des: '音創基地，全套音樂服務的社交空間；'
                },
                {
                  title: '未来生活馆：',
                  des: '暈集家居、服飾、美妝、旅遊、寵物等，融合科技為生活創造無限可能；'
                }]
            }
          },
          {
            id: 6,
            title: '活力基地',
            des: '為全民帶來健康與活力',
            banner: require('images/brand/66.png'),
            position: { title: '品牌定位', txt: '集運動和健康主題于一體的智慧生態圈' },
            bizs: {
              title: '業務體系',
              item: [
                {
                  title: '運動版塊：',
                  des: '活力運動匯 / 活力冰之城 / 活力加油站 / 活力大球場 / 活力DIY；'
                },
                {
                  title: '健康版塊：',
                  des: '有賞馬拉松/ 健康導航，以硬體加軟體組合方式為消費者提供健康管理服務；'
                },
                {
                  title: '虛擬版塊：',
                  des: '無人零售 Brand Stag/e虛擬馬拉松；'
                }
              ]
            }
          }
        ]
      }
    }
  },
  components: {},
  computed: {},
  created () {
    this.id = parseInt(this.$route.params.id) || 1
    this.showData.BRANDS.forEach(b => {
      if (b.id === this.id) {
        this.brand = b
      }
    })
  },
  watch: {
    language (newVal) {
      this.id = parseInt(this.$route.params.id) || 1
      this.showData.BRANDS.forEach(b => {
        if (b.id === this.id) {
          this.brand = b
        }
      })
    }
  },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.brandinfo {
  padding: px2rem(74) px2rem(12) px2rem(12);
  h4 {
    font-size: px2rem(17);
    color: #3c3c3c;
    margin-bottom: px2rem(10);
    font-weight: bold;
  }
  p {
    font-size: px2rem(14);
    color: #999999;
  }
  &-img {
    width: 100%;
    margin: px2rem(10) 0;
  }
  &-title {
    font-size: px2rem(15);
    color: #3c3c3c;
    position: relative;
    padding-left: px2rem(20);
    margin-bottom: px2rem(8);
    line-height: px2rem(21);
    font-weight: bold;
    &-p {
      margin: px2rem(5) 0 px2rem(20) 0;
    }
    img {
      position: absolute;
      width: px2rem(16);
      height: px2rem(16);
      left: 0;
      top: px2rem(2);
    }
  }
  &-biz {
    &-title {
      color: #3c3c3c;
      font-weight: bold;
    }
    &-des {
      line-height: px2rem(20);
    }
  }
  &-gtwork {
    &-ul {
      width: 100%;
      overflow: auto;
      white-space: nowrap;
      margin: px2rem(20) 0;
      li {
        display: inline-block;
        margin: px2rem(5);
        width: px2rem(180);
        img {
          width: 100%;
        }
      }
    }
  }
  &-footer {
    padding: px2rem(12) 0 px2rem(50);
  }
}
</style>
